module.exports = __webpack_public_path__ + "img/image25.9de6b270.jpg";